(function () {
  'use strict';

  var T = window.theme || { routes: {}, strings: {} };
  var $ = function (sel, root) { return (root || document).querySelector(sel); };
  var $$ = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };

  /* ---------- Money ---------- */
  function formatMoney(cents, format) {
    format = format || T.moneyFormat || '{{amount}}';
    var value = Number(cents) / 100;
    var match = format.match(/\{\{\s*(\w+)\s*\}\}/);
    var type = match ? match[1] : 'amount';
    var fmt = function (n, dec, thou, decSep) {
      var parts = n.toFixed(dec).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thou);
      return parts.join(decSep);
    };
    var out;
    switch (type) {
      case 'amount_no_decimals': out = fmt(value, 0, ',', '.'); break;
      case 'amount_with_comma_separator': out = fmt(value, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': out = fmt(value, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': out = fmt(value, 2, "'", '.'); break;
      case 'amount_with_space_separator': out = fmt(value, 2, ' ', ','); break;
      default: out = fmt(value, 2, ',', '.');
    }
    return format.replace(/\{\{\s*\w+\s*\}\}/, out);
  }

  function parseHTML(html) {
    return new DOMParser().parseFromString(html, 'text/html');
  }

  /* ---------- Header ---------- */
  var header = $('[data-header]');
  if (header && header.classList.contains('site-header--sticky')) {
    var onScroll = function () { header.classList.toggle('is-scrolled', window.scrollY > 8); };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  var mobileMenu = $('[data-mobile-menu]');
  function openMenu() {
    if (!mobileMenu) return;
    mobileMenu.hidden = false;
    document.body.classList.add('menu-open');
    $$('[data-menu-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    var panel = $('.mobile-menu__panel', mobileMenu);
    if (panel) panel.focus();
  }
  function closeMenu() {
    if (!mobileMenu || mobileMenu.hidden) return;
    mobileMenu.hidden = true;
    document.body.classList.remove('menu-open');
    $$('[data-menu-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
  }

  $$('[data-nav-details]').forEach(function (details) {
    details.addEventListener('toggle', function () {
      if (!details.open) return;
      $$('[data-nav-details]').forEach(function (other) { if (other !== details) other.open = false; });
    });
  });
  var headerSearch = $('[data-header-search]');
  if (headerSearch) {
    headerSearch.addEventListener('toggle', function () {
      if (headerSearch.open) { var input = $('[data-search-input]', headerSearch); if (input) input.focus(); }
    });
  }
  document.addEventListener('click', function (e) {
    $$('[data-nav-details], [data-header-search]').forEach(function (d) {
      if (d.open && !d.contains(e.target)) d.open = false;
    });
  });

  /* ---------- Cart ---------- */
  var Cart = {
    drawer: $('[data-cart-drawer]'),
    open: function () {
      if (!this.drawer) return;
      this.drawer.classList.add('is-open');
      this.drawer.setAttribute('aria-hidden', 'false');
      document.body.classList.add('drawer-open');
      var panel = $('.cart-drawer__panel', this.drawer);
      if (panel) panel.focus();
    },
    close: function () {
      if (!this.drawer) return;
      this.drawer.classList.remove('is-open');
      this.drawer.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('drawer-open');
    },
    replaceDrawer: function (html) {
      if (!this.drawer || !html) return;
      var fresh = $('[data-cart-drawer-content]', parseHTML(html));
      var current = $('[data-cart-drawer-content]', this.drawer);
      if (fresh && current) current.innerHTML = fresh.innerHTML;
    },
    replacePage: function (html) {
      var page = $('[data-cart-page]');
      if (!page || !html) return;
      var fresh = $('[data-cart-page]', parseHTML(html));
      if (fresh) page.innerHTML = fresh.innerHTML;
    },
    setCount: function (count) {
      $$('[data-cart-count]').forEach(function (el) {
        el.textContent = count;
        el.classList.toggle('is-empty', count === 0);
      });
    },
    refresh: function () {
      var self = this;
      var page = $('[data-cart-page]');
      var sections = ['cart-drawer'];
      if (page) sections.push(page.dataset.sectionId);
      return fetch(T.routes.root + '?sections=' + sections.join(','))
        .then(function (r) { return r.json(); })
        .then(function (data) {
          self.replaceDrawer(data['cart-drawer']);
          if (page) self.replacePage(data[page.dataset.sectionId]);
          return fetch(T.routes.cart + '.js').then(function (r) { return r.json(); });
        })
        .then(function (cart) { self.setCount(cart.item_count); });
    },
    change: function (line, quantity, lineEl) {
      var self = this;
      var page = $('[data-cart-page]');
      var sections = ['cart-drawer'];
      if (page) sections.push(page.dataset.sectionId);
      if (lineEl) lineEl.classList.add('is-busy');
      return fetch(T.routes.cartChange, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ line: line, quantity: quantity, sections: sections.join(','), sections_url: window.location.pathname })
      })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (data.sections) {
            self.replaceDrawer(data.sections['cart-drawer']);
            if (page) self.replacePage(data.sections[page.dataset.sectionId]);
          }
          if (typeof data.item_count === 'number') self.setCount(data.item_count);
        })
        .catch(function () { if (lineEl) lineEl.classList.remove('is-busy'); });
    }
  };

  var qtyTimer = null;
  document.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target : null;
    if (!t) return;
    if (t.closest('[data-cart-open]')) { e.preventDefault(); Cart.open(); return; }
    if (t.closest('[data-cart-close]')) { e.preventDefault(); Cart.close(); return; }
    if (t.closest('[data-menu-open]')) { e.preventDefault(); openMenu(); return; }
    if (t.closest('[data-menu-close]')) { e.preventDefault(); closeMenu(); return; }

    var minus = t.closest('[data-qty-minus]');
    var plus = t.closest('[data-qty-plus]');
    if (minus || plus) {
      var wrap = (minus || plus).closest('.qty');
      var input = wrap && $('input', wrap);
      if (!input) return;
      var min = Number(input.min || 0);
      var val = Number(input.value || 0) + (plus ? 1 : -1);
      if (val < min) val = min;
      input.value = val;
      input.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }

    var remove = t.closest('[data-line-remove]');
    if (remove) {
      e.preventDefault();
      Cart.change(Number(remove.dataset.line), 0, remove.closest('.cart-line'));
      return;
    }

    var filtersToggle = t.closest('[data-filters-toggle]');
    if (filtersToggle) {
      var filters = $('[data-filters]');
      if (!filters) return;
      var open = !filters.classList.contains('is-open');
      filters.classList.toggle('is-open', open);
      filtersToggle.setAttribute('aria-expanded', String(open));
      document.body.classList.toggle('menu-open', open);
      return;
    }
    if (t.closest('[data-filters-close]')) {
      var f = $('[data-filters]');
      if (f) { f.classList.remove('is-open'); document.body.classList.remove('menu-open'); }
    }
  });

  document.addEventListener('change', function (e) {
    var input = e.target;
    if (input.matches && input.matches('[data-line-qty]')) {
      clearTimeout(qtyTimer);
      qtyTimer = setTimeout(function () {
        Cart.change(Number(input.dataset.line), Number(input.value), input.closest('.cart-line'));
      }, 250);
    }
    if (input.matches && input.matches('[data-sort-select]')) {
      input.form && input.form.submit();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      Cart.close();
      closeMenu();
      var f = $('[data-filters]');
      if (f && f.classList.contains('is-open')) { f.classList.remove('is-open'); document.body.classList.remove('menu-open'); }
    }
  });

  /* ---------- Product ---------- */
  function initProduct(root) {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    var form = $('[data-product-form]', root);
    var variantsEl = $('[data-variants]', root);
    if (!form || !variantsEl) return;

    var variants = [];
    try { variants = JSON.parse(variantsEl.textContent); } catch (err) { return; }

    var idInput = $('[data-variant-id]', form);
    var addBtn = $('[data-add-to-cart]', form);
    var addText = $('[data-add-text]', form);
    var errorEl = $('[data-form-error]', form);
    var priceWrap = $('[data-price-wrap]', root);
    var mainImg = $('#ProductMainImage', root);
    var fieldsets = $$('fieldset.option', root);
    var thumbs = $$('[data-thumb]', root);
    var delivery = $('[data-delivery]', root);

    /* Lightbox */
    var lightbox = $('[data-lightbox]', root);
    var lbItems = [];
    var lbIndex = 0;
    if (lightbox) {
      try { lbItems = JSON.parse($('[data-lightbox-items]', lightbox).textContent); } catch (err) { lbItems = []; }
      var lbImg = $('[data-lightbox-img]', lightbox);
      var lbCounter = $('[data-lightbox-counter]', lightbox);
      var showLb = function (i) {
        if (!lbItems.length) return;
        lbIndex = (i + lbItems.length) % lbItems.length;
        lbImg.src = lbItems[lbIndex].src;
        lbImg.alt = lbItems[lbIndex].alt || '';
        if (lbCounter) lbCounter.textContent = (lbIndex + 1) + ' / ' + lbItems.length;
      };
      var openLb = function (start) {
        showLb(start || 0);
        lightbox.hidden = false;
        document.body.classList.add('drawer-open');
        var closeBtn = $('.lightbox__close', lightbox);
        if (closeBtn) closeBtn.focus();
      };
      var closeLb = function () { lightbox.hidden = true; document.body.classList.remove('drawer-open'); };
      var mobileMain = $('[data-mobile-main]', root);
      var mobileQuery = window.matchMedia('(max-width: 900px)');
      $$('[data-lightbox-open]', root).forEach(function (opener) {
        opener.addEventListener('click', function () {
          var index = Number(opener.dataset.index || 0);
          // On small screens a thumbnail swaps the large image; the large image opens the gallery.
          if (mobileQuery.matches && mobileMain && opener.hasAttribute('data-tile')) {
            var img = $('img', mobileMain);
            if (img && opener.dataset.mainSrc) {
              img.src = opener.dataset.mainSrc;
              img.removeAttribute('srcset');
            }
            mobileMain.dataset.index = index;
            $$('[data-tile]', root).forEach(function (t) { t.classList.toggle('is-active', t === opener); });
            return;
          }
          openLb(index);
        });
      });
      $$('[data-lightbox-close]', lightbox).forEach(function (b) { b.addEventListener('click', closeLb); });
      var prev = $('[data-lightbox-prev]', lightbox);
      var next = $('[data-lightbox-next]', lightbox);
      if (prev) prev.addEventListener('click', function () { showLb(lbIndex - 1); });
      if (next) next.addEventListener('click', function () { showLb(lbIndex + 1); });
      document.addEventListener('keydown', function (e) {
        if (lightbox.hidden) return;
        if (e.key === 'Escape') closeLb();
        if (e.key === 'ArrowLeft') showLb(lbIndex - 1);
        if (e.key === 'ArrowRight') showLb(lbIndex + 1);
      });
    }

    function selectedOptions() {
      return fieldsets.map(function (fs) {
        var checked = $('input:checked', fs);
        return checked ? checked.value : null;
      });
    }
    function findVariant(opts) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        var ok = true;
        for (var j = 0; j < opts.length; j++) { if (v.options[j] !== opts[j]) { ok = false; break; } }
        if (ok) return v;
      }
      return null;
    }
    function markAvailability(opts) {
      fieldsets.forEach(function (fs, i) {
        $$('input', fs).forEach(function (input) {
          var exists = variants.some(function (v) {
            if (!v.available) return false;
            for (var j = 0; j < opts.length; j++) {
              if (j === i) { if (v.options[j] !== input.value) return false; }
              else if (opts[j] !== null && v.options[j] !== opts[j]) return false;
            }
            return true;
          });
          var label = input.nextElementSibling;
          if (label) label.classList.toggle('is-unavailable', !exists);
        });
      });
    }
    function setActiveThumb(mediaId) {
      thumbs.forEach(function (tb) { tb.classList.toggle('is-active', Number(tb.dataset.mediaId) === mediaId); });
    }
    function render(variant) {
      if (!variant) {
        if (addBtn) addBtn.disabled = true;
        if (addText) addText.textContent = T.strings.unavailable;
        return;
      }
      if (idInput) idInput.value = variant.id;

      if (priceWrap) {
        var current = $('[data-price-current]', priceWrap);
        var compare = $('[data-price-compare]', priceWrap);
        var wrap = $('[data-price]', priceWrap);
        var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
        if (current) current.innerHTML = formatMoney(variant.price);
        if (compare) { compare.hidden = !onSale; if (onSale) compare.innerHTML = formatMoney(variant.compare_at_price); }
        if (wrap) wrap.classList.toggle('price--sale', !!onSale);
      }

      if (addBtn) addBtn.disabled = !variant.available;
      if (addText) addText.textContent = variant.available ? T.strings.addToCart : T.strings.soldOut;
      if (delivery) {
        delivery.textContent = variant.available ? delivery.dataset.in : delivery.dataset.out;
        delivery.classList.toggle('product__delivery--in', !!variant.available);
        delivery.classList.toggle('product__delivery--out', !variant.available);
      }

      if (variant.featured_image && mainImg) {
        mainImg.src = variant.featured_image.src;
        mainImg.removeAttribute('srcset');
        if (variant.featured_media) setActiveThumb(variant.featured_media.id);
      }

      fieldsets.forEach(function (fs, i) {
        var sel = $('[data-option-selected]', fs);
        if (sel) sel.textContent = variant.options[i];
      });

      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    fieldsets.forEach(function (fs) {
      fs.addEventListener('change', function () {
        var opts = selectedOptions();
        markAvailability(opts);
        render(findVariant(opts));
      });
    });
    if (fieldsets.length) markAvailability(selectedOptions());

    thumbs.forEach(function (tb) {
      tb.addEventListener('click', function () {
        if (!mainImg) return;
        mainImg.src = tb.dataset.src;
        mainImg.removeAttribute('srcset');
        setActiveThumb(Number(tb.dataset.mediaId));
      });
    });

    form.addEventListener('submit', function (e) {
      if (T.cartType !== 'drawer' || !Cart.drawer) return;
      e.preventDefault();
      if (errorEl) errorEl.hidden = true;
      var prevText = addText ? addText.textContent : '';
      if (addBtn) { addBtn.classList.add('is-loading'); addBtn.disabled = true; }

      var fd = new FormData(form);
      fd.append('sections', 'cart-drawer');
      fd.append('sections_url', window.location.pathname);

      fetch(T.routes.cartAdd, { method: 'POST', headers: { 'Accept': 'application/json' }, body: fd })
        .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
        .then(function (res) {
          if (!res.ok || res.data.status) throw new Error(res.data.description || res.data.message || 'Fehler');
          if (res.data.sections) Cart.replaceDrawer(res.data.sections['cart-drawer']);
          return fetch(T.routes.cart + '.js').then(function (r) { return r.json(); });
        })
        .then(function (cart) {
          Cart.setCount(cart.item_count);
          Cart.open();
          if (addText) { addText.textContent = T.strings.added; setTimeout(function () { addText.textContent = prevText; }, 1600); }
        })
        .catch(function (err) {
          if (errorEl) { errorEl.textContent = err.message; errorEl.hidden = false; }
          if (addText) addText.textContent = prevText;
        })
        .then(function () {
          if (addBtn) { addBtn.classList.remove('is-loading'); addBtn.disabled = false; }
        });
    });
  }

  /* ---------- Related products ---------- */
  function initRelated(el) {
    if (!el.dataset.url || el.dataset.initialized) return;
    el.dataset.initialized = 'true';
    fetch(el.dataset.url)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var fresh = $('[data-related]', parseHTML(html));
        if (fresh && fresh.innerHTML.trim()) el.innerHTML = fresh.innerHTML;
        else el.remove();
      })
      .catch(function () { el.remove(); });
  }

  /* ---------- Countdown ---------- */
  function initCountdown(el) {
    if (el.dataset.initialized) return;
    el.dataset.initialized = 'true';
    var target = new Date(el.dataset.target);
    if (isNaN(target.getTime())) return;
    var nums = {};
    $$('[data-cd]', el).forEach(function (n) { nums[n.dataset.cd] = n; });
    var wrap = $('.countdown', el);
    var expired = $('[data-countdown-expired]', el);
    var pad = function (n) { return String(n).length < 2 ? '0' + n : String(n); };
    var timer = null;
    var tick = function () {
      var diff = target.getTime() - Date.now();
      if (diff <= 0) {
        if (wrap) wrap.hidden = true;
        if (expired) expired.hidden = false;
        if (timer) clearInterval(timer);
        return;
      }
      if (nums.days) nums.days.textContent = Math.floor(diff / 864e5);
      if (nums.hours) nums.hours.textContent = pad(Math.floor((diff % 864e5) / 36e5));
      if (nums.minutes) nums.minutes.textContent = pad(Math.floor((diff % 36e5) / 6e4));
      if (nums.seconds) nums.seconds.textContent = pad(Math.floor((diff % 6e4) / 1e3));
    };
    tick();
    timer = setInterval(tick, 1000);
  }

  /* ---------- Init (initial load + theme editor section loads) ---------- */
  function initSections(scope) {
    $$('[data-product]', scope).forEach(initProduct);
    $$('[data-related]', scope).forEach(initRelated);
    $$('[data-countdown]', scope).forEach(initCountdown);
  }
  initSections(document);

  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (e) { initSections(e.target); });
  }
})();
